
<div class="table-fms max-height-77vh overflow-x-auto" *ngVar="{
  teamsWithAccess: usersTable?.[0]?.users || [],
  teamsWithOutAccess: usersTable?.[1]?.users || []
} as teamsForSorting">
  <table>
    <thead>
    <tr *ngIf="isAdmin">
      <th colspan="6" class="no-hover"></th>
      <th class="blank-space no-hover"></th>
      <th [attr.colspan]="organizationAccountId ? 7 : 6 ">
        <div class="centered-row-container">
          Software access
        </div>
      </th>
      <th class="blank-space no-hover"></th>
      <th colspan="2">
        <div class="centered-row-container">
          Notifications
        </div>
      </th>
    </tr>
    <tr>
      <th class="width-2"></th>
      <th data-qa="name"
        class="fix-w-10p25"
        appSort
        [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
        [keySelector]="teamSort.byName">
        Name
      </th>
      <th data-qa="workspace"
        class="fix-w-5p5"
        appSort
        [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
        [keySelector]="teamSort.byWorkSpace">
        Workspace
      </th>
      <th data-qa="position"
        class="fix-w-5p5"
        appSort
        [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
        [keySelector]="teamSort.byPosition">
        Position
      </th>
      <th data-qa="email"
        class="fix-w-5p5"
        appSort
        [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
        [keySelector]="teamSort.byEmail">
        Email
      </th>
      <th data-qa="phone"
        appSort
        [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
        [keySelector]="teamSort.byPhone">
        Phone
      </th>
      <ng-container *ngIf="isAdmin">
        <th class="blank-space no-hover"></th>
        <th data-qa="fund-performance"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byFmsAccessLevel">
            <div class="flex flex-col">
              <span>Fund</span>
              <span>performance</span>
            </div>
        </th>
        <th data-qa="performance-kpi"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byKPIAccessLevel">
          <div class="flex flex-col">
            <span>Performance</span>
            <span>KPIs</span>
          </div>
        </th>
        <th *ngIf="organizationAccountId"
          data-qa="investor-portal"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byPortalAccessLevel">
          <div class="flex flex-col">
            <span>Investor</span>
            <span>portal</span>
          </div>
        </th>
        <th data-qa="pdf"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byPortalPdfAccessLevel">
            <div class="flex flex-col">
              <span>PDF report</span>
              <span>generator</span>
            </div>
        </th>
        <th data-qa="market-analysis"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byMarketAnalysisAccessLevel">
          <div class="flex flex-col">
            <span>Market</span>
            <span>analysis</span>
          </div>
        </th>
        <th data-qa="fs"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byFinancialStatementAccessLevel">
          <div class="flex flex-col">
            <span>Financial</span>
            <span>statement</span>
          </div>
        </th>
        <th data-q="data-room"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byDataRoomAccessLevel">
          <div class="flex flex-col">
            <span>Data</span>
            <span>room</span>
          </div>
        </th>
        <th class="blank-space no-hover"></th>
        <th data-qa="document-uploaded"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byDocumentsUploaded">
          <div class="flex flex-col ">
            <span>Documents</span>
            <span>uploaded</span>
          </div>
        </th>
        <th data-qa="kpi-submitted"
          appSort
          [arr]="[teamsForSorting.teamsWithAccess, teamsForSorting.teamsWithOutAccess]"
          [keySelector]="teamSort.byKpiSubmitted">
          <div class="flex flex-col">
            <span>KPI</span>
            <span>submitted</span>
          </div>
        </th>
      </ng-container>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let usersTable of usersTable">
      <tr *ngIf="usersTable.users?.length" class="clickable" (click)="usersTable.opened = !usersTable.opened">
        <td class="blank-space no-hover">
          <app-table-group-icon [opened]="usersTable.opened"></app-table-group-icon>
        </td>
        <td class="type-text active-sold">
          <span class="light-bold">{{usersTable.type}}</span>
        </td>
        <td *ngIf="isAdmin" colspan="4"></td>
        <td *ngIf="isAdmin" class="blank-space no-hover"></td>
        <td colspan="7"></td>
        <td *ngIf="isAdmin" class="blank-space no-hover"></td>
        <td *ngIf="isAdmin"></td>
        <td *ngIf="isAdmin"></td>
      </tr>
      <ng-container *ngIf="usersTable.opened">
        <tr *ngFor="let t of usersTable.users; let i = index">
          <ng-container *ngVar="t.accessLevel !== 'No Access' as hasAccess">
            <td [class]="{'blank-space no-hover': !isAdmin}">
              <app-three-dots-menu
                *ngIf="isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)"
                [matMenuTriggerFor]="menu"
                (click)="chosenUserEmitter(t)">
              </app-three-dots-menu>
              <mat-menu #menu="matMenu">
                <ul class="list">

                  <app-drop-down-item
                    *ngIf="t.accessLevel !== 'No Access' || t.portalAdminAccess || t.portalPdf || t.marketAnalysis"
                    data-qa="member-resend-invite"
                    class="width-100pcnt"
                    [text]="'Resend invite'"
                    [iconNameAndStyling]="'letter.svg'"
                    (click)="threeDotsMenuFields.resendInvite = true; threeDotsClickedEmitter()">
                  </app-drop-down-item>

                  <app-drop-down-item
                    data-qa="member-edit"
                    class="width-100pcnt"
                    [text]="'Edit'"
                    [iconNameAndStyling]="'edit-outline.svg'"
                    (click)="threeDotsMenuFields.edit = true; threeDotsClickedEmitter()">
                  </app-drop-down-item>

                  <app-drop-down-item
                    *ngIf="!(t.mail === currentUser.mail && orgAccess.isOrganizationAdmin)"
                    data-qa="member-delete"
                    class="width-100pcnt"
                    [text]="'Delete'"
                    [iconNameAndStyling]="'delete.svg; red-10'"
                    [menuItemClass]="'red'"
                    (click)="threeDotsMenuFields.delete = true; threeDotsClickedEmitter()">
                  </app-drop-down-item>
                </ul>
              </mat-menu>

            </td>
            <td [attr.data-qa]="'name' + i"
              class="fix-w-10p25">
              <div *ngVar="t.name + ' ' + (t.family ?? '') as nameAndSurname"
                class="start-row-container row-gap-0p3125">
                <span [attr.data-qa]="'name-family' + i"
                  class="whitespace-nowrap"
                  [id]="'name-family-' + i"
                  (mouseenter)="activateTooltip('name-family-' + i, nameAndSurname)"
                  (mouseleave)="showTooltip = false">
                  {{nameAndSurname | linkShort: MAX_DESC_LEN}}
                </span>
                <div *ngIf="t.organizationAdmin"
                  [attr.data-qa]="'org-admin-badge-' + t.name"
                  [id]="'orgAdm_' + i"
                  class="org-admin-label br-6p875 font-size-0p625 min-width-3p5 flex-none"
                  (mouseenter)="activateTooltipWithOrgAdmin('orgAdm_' + i, t.organizationAdmin)"
                  (mouseleave)="showTooltip = false">
                  Org. admin
                  </div>
              </div>
              <span *ngIf="orgAccess.isSuperAdmin"
                    class="black-9">Last login: {{t.userStats?.lastLogin | lastLogin}} </span>
            </td>
            <td [attr.data-qa]="'workspace' + i">{{t.companyName}}</td>
            <td [attr.data-qa]="'position' + i"
              class="fix-w-5p5">
              {{t.position}}
            </td>
            <td [attr.data-qa]="'mail' + i"
              class="fix-w-5p5 clickable"
              [id]="'email' + usersTable.type + i"
              (mouseenter)="activateTooltip('email'+ usersTable.type + i, t.mail)"
              (mouseleave)="showTooltip = false">
              <span class="link-color"
                (click)="sendEmail(t.mail)">{{t.mail | linkShort: MAX_DESC_LEN}}</span>
            </td>
            <td [attr.data-qa]="'phone' + i">{{t.phone | dashInsteadOfNull }}</td>
            <ng-container *ngIf="isAdmin">
              <ng-container *ngVar="orgAccess.isSuperAdmin || orgAccess.isOrganizationAdmin as isOrgSuperAdmin">
                <td class="blank-space no-hover"></td>
                <td [attr.data-qa]="'fund-performance'+ i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else fmsAccessLevelText"
                    data-qa="team-selector-fms"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="roles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.fmsAccess"
                    [selectedItem]="selectedOrganization.fmsAccess ? currentRoles[t.accessLevel] : null"
                    [defaultPlaceholder]="selectedOrganization.fmsAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateAccessLevel(t, $event.role)">
                  </app-selector>
                  <ng-template #fmsAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.fmsAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.accessLevel]">
                      </app-all-icons>
                      {{selectedOrganization.fmsAccess ? t.accessLevel : NOT_IN_PLAN_TEXT}}
                    </div>
                  </ng-template>
                </td>
                <td [attr.data-qa]="'performance' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else kpiAccessLevelText"
                    data-qa="team-selector-kpi-access"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="kpiAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.kpiAccess"
                    [selectedItem]="selectedOrganization.kpiAccess ? currentRoles[t.kpiAccessLevel] : null"
                    [defaultPlaceholder]="selectedOrganization.kpiAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateKpiAccessLevel(t, $event.role)">
                  </app-selector>
                  <ng-template #kpiAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.kpiAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.kpiAccessLevel]">
                      </app-all-icons>
                      {{selectedOrganization.kpiAccess ? t.kpiAccessLevel : NOT_IN_PLAN_TEXT}}
                    </div>
                  </ng-template>
                </td>
                <td *ngIf="organizationAccountId"
                [attr.data-qa]="'investor-portal' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else portalAccessLevelText"
                    data-qa="team-selector-portal"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="portalAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.portalAccess"
                    [selectedItem]="selectedOrganization.portalAccess ?
                      (t.portalAdminAccess ? currentRoles.Admin : currentRoles['No Access']) : null"
                    [defaultPlaceholder]="selectedOrganization.portalAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateCheckBoxInDB(t, employeeCheckboxFields.adminPortal, hasPortalAccess($event.role))">
                  </app-selector>
                  <ng-template #portalAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.portalAccess"
                        [iconNameAndStyling]="iconForUserRoles[
                          t.portalAdminAccess ? currentRoles.Admin.role : currentRoles['No Access'].role]">
                      </app-all-icons>
                      {{selectedOrganization.portalAccess ?
                      (t.portalAdminAccess ? currentRoles.Admin.role : currentRoles['No Access'].role) : NOT_IN_PLAN_TEXT}}
                    </div>
                  </ng-template>
                </td>
                <td [attr.data-qa]="'pdf' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else pdfAccessLevelText"
                    data-qa="team-selector-pdf"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="pdfAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.pdfAccess"
                    [selectedItem]="selectedOrganization.pdfAccess ?
                      (t.portalPdf ? pdfAccessRoles[0] : pdfAccessRoles[1]) : null"
                    [defaultPlaceholder]="selectedOrganization.pdfAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateCheckBoxInDB(t, employeeCheckboxFields.portalPdf, hasPDFAccess($event.role))">
                  </app-selector>
                  <ng-template #pdfAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.pdfAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.portalPdf ? pdfAccessRoles[0].role : pdfAccessRoles[1].role]">
                      </app-all-icons>
                      {{selectedOrganization.pdfAccess ?
                        (t.portalPdf ? pdfAccessRoles[0].role : pdfAccessRoles[1].role) : NOT_IN_PLAN_TEXT}}
                    </div>
                  </ng-template>
                </td>
                <td [attr.data-qa]="'market-analysis' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else MarketAnalysisAccessLevelText"
                    data-qa="team-selector-market-analysis"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="marketAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.marketAnalysisAccess"
                    [selectedItem]="selectedOrganization.marketAnalysisAccess ?
                      (t.marketAnalysis ? marketAccessRoles[0] : marketAccessRoles[1]) : null"
                    [defaultPlaceholder]="selectedOrganization.marketAnalysisAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateCheckBoxInDB(t, employeeCheckboxFields.marketAnalysis, hasMarketAnalysisAccess($event.role))">
                  </app-selector>
                  <ng-template #MarketAnalysisAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.marketAnalysisAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.marketAnalysis ? marketAccessRoles[0].role : marketAccessRoles[1].role]">
                      </app-all-icons>
                      {{selectedOrganization.marketAnalysisAccess ?
                        (t.marketAnalysis ? marketAccessRoles[0].role : marketAccessRoles[1].role) : NOT_IN_PLAN_TEXT }}
                    </div>
                  </ng-template>
                </td>
                <td [attr.data-qa]="'fs' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else FinancialStatementAccessLevelText"
                    data-qa="team-selector-financial-statement"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="financialStatementAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.financialStatementAccess"
                    [selectedItem]="selectedOrganization.financialStatementAccess ?
                      currentRoles[t.financialStatementAccessLevel] : null"
                    [defaultPlaceholder]="selectedOrganization.financialStatementAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateFinancialStatementAccessLevel(t, $event.role)">
                  </app-selector>
                  <ng-template #FinancialStatementAccessLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.financialStatementAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.financialStatementAccessLevel]">
                      </app-all-icons>
                      {{selectedOrganization.financialStatementAccess ? t.financialStatementAccessLevel : NOT_IN_PLAN_TEXT}}
                    </div>
                  </ng-template>
                </td>
                <td [attr.data-qa]="'data-room' + i">
                  <app-selector
                    *ngIf="isOrgSuperAdmin; else DataRoomLevelText"
                    data-qa="team-selector-data-room"
                    class="clickable selector-wrapper arrow-change-color"
                    [outerClass]="'control-shrinked-container'"
                    [data]="dataRoomAccessRoles"
                    [field]="'displayRole'"
                    [disabled]="t.organizationAdmin || !selectedOrganization.dataRoomAccess"
                    [selectedItem]="selectedOrganization.dataRoomAccess ?
                      (t.dataRoomAccess ? dataRoomAccessRoles[0] : dataRoomAccessRoles[1]) : null"
                    [defaultPlaceholder]="selectedOrganization.dataRoomAccess ? '-' : NOT_IN_PLAN_TEXT"
                    [openOnClick]="true"
                    [withArrow]="true"
                    (itemEmitter)="updateCheckBoxInDB(t, employeeCheckboxFields.dataRoom, hasDataRoomAccess($event.role))">
                  </app-selector>
                  <ng-template #DataRoomLevelText>
                    <div class="start-row-container">
                      <app-all-icons
                        *ngIf="selectedOrganization.dataRoomAccess"
                        [iconNameAndStyling]="iconForUserRoles[t.dataRoomAccess ? dataRoomAccessRoles[0].role : dataRoomAccessRoles[1].role]">
                      </app-all-icons>
                      {{selectedOrganization.dataRoomAccess ?
                      (t.dataRoomAccess ? dataRoomAccessRoles[0].role : dataRoomAccessRoles[1].role) : NOT_IN_PLAN_TEXT }}
                    </div>
                  </ng-template>
                </td>
                <td class="blank-space no-hover"></td>
                <td [attr.data-qa]="'document-uploaded' + i">
                  <div class="centered-row-container">
                    <app-checkbox
                      data-qa="team-portfolio-notification-checkbox"
                      [checked]="t.portfolioNotification"
                      [disabled]="!((orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin) && selectedOrganization?.fmsAccess)"
                      (change)="updateCheckBoxInDB(t, employeeCheckboxFields.portfolioNotification, !t.portfolioNotification)">
                    </app-checkbox>
                  </div>
                </td>
                <td [attr.data-qa]="'kpi-submitted' + i">
                  <div class="centered-row-container">
                    <app-checkbox
                      data-qa="team-kpi-notification-checkbox"
                      [checked]="t.kpiNotification"
                      [disabled]="!((orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin) && selectedOrganization?.fmsAccess)"
                      (change)="updateCheckBoxInDB(t, employeeCheckboxFields.kpiNotification, !t.kpiNotification)">
                    </app-checkbox>
                  </div>
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
    </tbody>
  </table>
</div>
<app-tooltip
  *ngIf="showTooltip"
  [coordinates]="tooltipCoordinates"
  [title]="toolTipTitle"
/>
